// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Qm+Ts","title":"styles_title__4IsdQ"};